import cx from 'classnames';
import React from 'react';

import { ClassNameProps } from '../models/props/ClassNameProps';

const HorizontalButtonGroup: React.FC<ClassNameProps> = (props) => {
  return (
    <div className={cx('flex items-center gap-4', props.className)}>
      {props.children}
    </div>
  );
};

export default HorizontalButtonGroup;
